import { InfluencerProfileAudience, InfluencerProfileAudienceProps } from '../shared';

type InfluencerInstagramProfileAudienceProps = InfluencerProfileAudienceProps;

export const InfluencerInstagramProfileAudience = (props: InfluencerInstagramProfileAudienceProps) => (
  <InfluencerProfileAudience {...props} />
);
